
<div class="header-toolbar">
  <h1 *ngIf="mode === 'new'">{{ title }}</h1>
  <h1 *ngIf="mode === 'edit'">{{ dossier?.name }}</h1>
</div>

<form #form="ngForm" (ngSubmit)="save()" autocomplete="off" *ngIf="dossier">

  <!-- Toolbar -->
  <div class="main btn-toolbar">

    <div class="btn-group">
      <div class="content">

        <a class="btn" [routerLink]="['capitalisation']" *ngIf="mode === 'edit'" title="Importer la table de capitalisation">
          <t-icon name="add"></t-icon>
          <span class="text">Importer</span>
        </a>

      </div>
    </div>

    <div class="btn-group">    
      <div class="content">

        <a class="btn" [routerLink]="['report']" *ngIf="mode === 'edit'">
          <t-icon name="description"></t-icon>
          <span class="text">Rapport</span>
        </a>

        <a class="btn" [routerLink]="['organigramme']" *ngIf="mode === 'edit'">
          <t-icon name="device_hub"></t-icon>
          <span class="text">Organigramme</span>
        </a>
            
        <a class="btn" [routerLink]="['execute']" *ngIf="mode === 'edit'">
          <t-icon name="arrow_forward"></t-icon>
          <span class="text">Exécuter une opération</span>
        </a>

      </div>
    </div>

  </div>
  <!-- /Toolbar -->

  <div class="grid" *ngIf="dossier">

    <div class="column">

      <div class="panel">
        <h2>Données</h2>

        <t-dossier-tree 
          [tree]="dossierTree"
        
          (added)="add($event)"
          (deleted)="delete($event)"
          (selected)="selectItem($event)"
        
          (groupAdded)="addGroup($event)"
          (groupDeleted)="deleteGroup($event)"
          (groupDuplicated)="duplicateGroup($event)"
          (groupMoved)="moveGroup($event)"
        ></t-dossier-tree>

      </div>

      <div class="panel" *ngIf="dossier.slEntity">
        <h2>Registre des actions</h2>

        <div class="form-group">
          <label for="entityId">Identifiant</label>
          <span id="entityId" class="value">{{ dossier.slEntity.id }}</span>
        </div>

        <div class="form-group">
          <label for="currentVersion">Version liée</label>
          <span id="currentVersion" class="value">{{ dossier.sl_entity_version }}</span>
        </div>

        <div class="form-group" [ngClass]="{'highlight': slVersionMismatch }">
          <label for="lastVersion">Dernière version</label>
          <span id="lastVersion" class="value">{{ dossier.slEntity.version }}</span>
          
          <div class="text-right" *ngIf="slVersionMismatch">
            <a class="btn btn-small btn-primary" (click)="slUpdate($event)">
              <t-icon name="add"></t-icon>
              <span class="text">Importer la dernière version</span>
            </a>
          </div>
        </div>

      </div>

      <div *ngIf="mode === 'edit' && dossier.inpi" class="panel inpi-panel">
        <h2>INPI</h2>
        <span *ngIf="!dossier.inpi.message">
          <t-icon name="check"></t-icon>
          Données INPI valides
        </span>
        <span *ngIf="dossier.inpi.message">
          <t-icon name="warning"></t-icon>
          {{ dossier.inpi.message }}
        </span>
      </div>
      
      <div *ngIf="mode === 'edit'" class="panel">
        <h2>Autres</h2>

        <div class="form-group">
          <label for="id">Identifiant</label>
          <span id="id" class="value">{{ dossier.id }}</span>
        </div>

        <div class="form-group">
          <label for="created_at">Date d'ajout</label>
          <span id="created_at" class="value">{{ dossier.created_at | tzdate }}</span>
        </div>

        <div class="form-group">
          <label for="created_by">Ajouté par</label>
          <span id="created_by" class="value">{{ dossier.created_by.fullname }}</span>
        </div>

        <div class="form-group">
          <label for="created_at">Date de modification</label>
          <span id="created_at" class="value">{{ dossier.updated_at | tzdate }}</span>
        </div>

        <div class="form-group">
          <label for="updated_by">Modifié par</label>
          <span id="updated_by" class="value">{{ dossier.updated_by.fullname }}</span>
        </div>
      </div>
      
    </div>

    <div class="column">

      <div class="panel" *ngIf="selectedRecordLink">
        <h2 *ngIf="selectedRecordLink.id">Détails</h2>
        <h2 *ngIf="!selectedRecordLink.id && selectedRecordLink.record.id === undefined">Détails / Nouveau</h2>
        <h2 *ngIf="!selectedRecordLink.id && selectedRecordLink.record.id !== undefined">Détails / Attacher</h2>

        <div class="btn-toolbar">

          <a *ngIf="mode === 'edit' && !selectedRecordLink.id" class="btn btn-small btn-gray" (click)="lookupRecord($event)">
            <t-icon name="search"></t-icon>
            <span class="text">Recherche</span>
          </a>

          &nbsp;

          <button class="btn btn-small btn-gray" [disabled]="!selectedRecordLink.valid">
            <t-icon name="check"></t-icon>
            <span class="text" *ngIf="mode === 'new'">Enregistrer</span>
            <span class="text" *ngIf="mode === 'edit' && selectedRecordLink.id">Modifier</span>
            <span class="text" *ngIf="mode === 'edit' && !selectedRecordLink.id && selectedRecordLink.record.id === undefined">Ajouter</span>
            <span class="text" *ngIf="mode === 'edit' && !selectedRecordLink.id && selectedRecordLink.record.id !== undefined">Attacher</span>
          </button>

          &nbsp;

          <a class="btn btn-small btn-gray" (click)="cancel()">
            <t-icon name="close"></t-icon>
            <span class="text">Annuler</span>
          </a>
        </div>

        <t-record-link-form [link]="selectedRecordLink" [rootLink]="dossierTree.rootItem.link" (fixIssue)="selectRootItem()" [inpiFieldErrors]="dossier?.inpi?.errors"></t-record-link-form>

      </div>


      <div class="panel" *ngIf="selectedDataLink">
        <h2 *ngIf="selectedDataLink.id">Détails</h2>
        <h2 *ngIf="!selectedDataLink.id">Détails / Nouveau</h2>

        <div class="btn-toolbar">

          <button class="btn btn-small btn-gray" [disabled]="!selectedDataLink.valid">
            <t-icon name="check"></t-icon>
            <span class="text" *ngIf="selectedDataLink.id">Modifier</span>
            <span class="text" *ngIf="!selectedDataLink.id">Ajouter</span>
          </button>

          &nbsp;

          <a class="btn btn-small btn-gray" (click)="cancel()">
            <t-icon name="close"></t-icon>
            <span class="text">Annuler</span>
          </a>
        </div>

        <t-data-link-form [link]="selectedDataLink"></t-data-link-form>

      </div>

      <div class="panel" *ngIf="selectedLinkGroup">
        <h2 *ngIf="selectedLinkGroup.id">Détails</h2>
        <h2 *ngIf="!selectedLinkGroup.id">Détails / Nouveau</h2>

        <div class="btn-toolbar">

          <button class="btn btn-small btn-gray" [disabled]="!selectedLinkGroup.valid">
            <t-icon name="check"></t-icon>
            <span class="text" *ngIf="selectedLinkGroup.id">Modifier</span>
            <span class="text" *ngIf="!selectedLinkGroup.id">Ajouter</span>
          </button>

          &nbsp;

          <a class="btn btn-small btn-gray" (click)="cancel()">
            <t-icon name="close"></t-icon>
            <span class="text">Annuler</span>
          </a>
        </div>

        <t-link-group-form [group]="selectedLinkGroup"></t-link-group-form>

      </div>
      

    </div>

  </div>
</form>